import { render, staticRenderFns } from "./Allowance.vue?vue&type=template&id=32d7c60a&scoped=true"
import script from "./Allowance.vue?vue&type=script&lang=js"
export * from "./Allowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7c60a",
  null
  
)

export default component.exports